// eslint-disable-next-line frontbucket-patterns/no-new-emotion-styled
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const Divider = styled.hr({
  height: '1px',
  border: 0,
  backgroundColor: token('color.border'),
  margin: `${token('space.100')} 0`,
});

export const OnMergeDescription = styled.div({
  font: token('font.body.small'),
  fontWeight: token('font.weight.bold'),
  color: token('color.text.subtle'),
  marginTop: token('space.100'),
});
